import { ActionTree } from 'vuex'
import { MenuState } from '@/modules/cms/modules/menu/store'
import { RootState } from '@/store/types'
import { MutationTypes } from '@/modules/cms/modules/menu/store/mutations'
import * as api from '@/modules/cms/modules/menu/api'
import MenuEntry from '../model/MenuEntry';
import { notify, Colors } from '@/modules/core/notification';
import MenuType from '../model/MenuType';
import { ErrorType } from '@/api';
import * as linkApi from '@/modules/cms/modules/link/api'

const actions: ActionTree<MenuState, RootState> = {
    /**
     * Carga la lista de menus en el estado
     * @param param0
     * @param force
     */
    async loadMenuList ({commit, state}, force = false) {
        // La lista ya ha sido obtenida y no se ha solicitado la obtención
        // forzosa
        if (state.menuList.length && !force) {
            return
        }

        commit(MutationTypes.SetMenuList, await api.getMenuList())
    },

    /**
     * Carga un menu para mostrarlo al usuario
     *
     * @param param0
     * @param id
     */
    async loadMenu ({commit}, id: number) {
        try {
            commit(MutationTypes.SetCurrentMenu, await api.getMenu(id))
            commit(MutationTypes.ResetCurrentMenuItem)

            return true
        } catch (err) {
            // El error de la api indica que el recurso no existe, el menú al que la
            // aplicación intenta acceder no se encuentra registrado
            if (err.type === ErrorType.NotFound) {
                notify(`El menú con id ${id} no se encuentra registrado`, Colors.Error, {
                    notShowInCenter: true,
                })
            }

            return false
        }
    },

    /**
     * Crea un nuevo menú
     *
     * @param param0 { {commit} }
     */
    async createNewMenu ({commit}) {
        const menu = new MenuEntry()
        menu.type = MenuType.Main

        commit(MutationTypes.SetCurrentMenu, menu)
        commit(MutationTypes.ResetCurrentMenuItem)
    },

    /**
     * Carga en el estado la lista de posiciones para menús
     * @param param0
     */
    async loadSlotList ({state, commit}) {
        // La lista esta rellena no es necesario llamar al servidor
        if (state.slots.length) {
            return
        }

        const list = await api.getSlotList()
        if (!list.length) {
            notify(
                'No existe ninguna posición de menú registrada en la aplicación' +
                ', por favor, contacta con el servicio técnico', Colors.Warning)

            return
        }

        commit(MutationTypes.SetSlotList, list)
    },

    /**
     * Guarda los cambios realizados al menú actual en el servidor
     */
    async saveCurrentMenu ({state, commit}) {
        let menu = state.currentMenu

        // Si el menú es nuevo se registra en el servidor, si no, se actualiza
        // su información
        if (menu.isNew) {
            menu = await api.createMenu(menu)
        } else {
            menu = await api.updateMenu(menu)
        }


        // Remplaza el menu actual por el nuevo generado por el servidor
        commit(MutationTypes.SetCurrentMenu, menu)

        notify(`El menú se ha guardado correctamente`)
    },

    /**
     * Elimina un menú de la aplicación
     *
     * @param context
     * @param id
     */
    async deleteMenu (context, id: number) {
        await api.deleteMenu(id)
    },

    /**
     * Solicita a la API del CMS el enlace del elemento de menu actualmente
     * seleccionado
     */
    async loadCurrentMenuItemLink ({state, commit}) {
        const item = state.currentMenuItem
        if (!item.isResource) {
            throw new Error('No se puede genera el enlace de un item que no es un recurso')
        }

        const link = await linkApi.getResourceLink(item.resourceType, item.resourceId, item.attributes)
        commit(MutationTypes.UpdateMenuEntryField, {path: 'link', value: link})
    },
}

export default actions
